// Admin API URL (порт 9021)
const getAdminApiUrl = (): string => {
  // В production используется встроенное значение из сборки
  if (typeof process !== 'undefined' && process.env && process.env.API_URL) {
    return process.env.API_URL;
  }
  
  // В dev режиме используем локальный адрес
  // Можно переопределить через window.ENV_API_URL
  if (typeof window !== 'undefined' && (window as any).ENV_API_URL) {
    return (window as any).ENV_API_URL;
  }
  
  // По умолчанию для локальной разработки
  return 'http://localhost:9021';
};

// Shop API URL (порт 9020) - основной магазин, где хранятся слайды
const getShopApiUrl = (): string => {
  // В production используется встроенное значение из сборки
  if (typeof process !== 'undefined' && process.env && process.env.SHOP_API_URL) {
    return process.env.SHOP_API_URL;
  }
  
  // В dev режиме используем локальный адрес
  if (typeof window !== 'undefined' && (window as any).ENV_SHOP_API_URL) {
    return (window as any).ENV_SHOP_API_URL;
  }
  
  // По умолчанию для локальной разработки
  return 'http://localhost:9020';
};

export const API_CONFIG = {
  get baseUrl() {
    return getAdminApiUrl();
  },
  get shopApiUrl() {
    return getShopApiUrl();
  },
  timeout: 10000,
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem('adminToken');
};

export const setAuthToken = (token: string): void => {
  localStorage.setItem('adminToken', token);
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('adminToken');
};

